import { CommonModule } from '@angular/common';
import { Component, DestroyRef, ViewContainerRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ModalService } from '../../services/modal/modal.service';
import { ArticleService } from '../../services/article.service';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-create-article',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './create-article.component.html',
  styleUrl: './create-article.component.scss',
})
export class CreateArticleComponent {
  error?: string;
  form!: FormGroup;
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private articleService: ArticleService,
    private authService: AuthenticationService,
    private modalService: ModalService,
    private vcr: ViewContainerRef,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      name: fb.control('', Validators.required),
      unitOfMeasurement: fb.control('', Validators.required),
      price: fb.control(0.0, [Validators.required, Validators.min(0.0)]),
      active: fb.control(true, Validators.required),
    });
  }

  createArticle() {
    if (this.form.valid) {
      this.submitting = true;
      this.articleService.createArticle(this.form.value)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.submitting = false;

          this.form.reset();
          this.form.controls['active'].setValue(true);

          this.modalService.showSuccessDialog(
            this.vcr,
            'New article has been created.'
          );
        },
        error: (err: HttpErrorResponse) => {
          if (err.status == 401) {
            this.authService.logout();
          } else {
            this.submitting = false;
            this.error = err.error.message;
          }
        },
      });
    } else {
      this.error = 'Please fill the fields properly';
    }
  }
}
